import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";

import { BASE_URL } from "../Apis/apiConfig";
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LineChart, Line, AreaChart,
  Area, PieChart, Pie, Cell, } from "recharts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Users, FileText, AlertCircle, Megaphone, Briefcase, ShieldAlert, Receipt, FileMinus, BarChart2, BookOpen,
  FileIcon, Car, Calendar, ArrowUpRight, TrendingUp, DollarSign, UserCheck, Clock,  CheckCircle, AlertTriangle,
} from "lucide-react";


const cardConfig = [ {label: "Complaints Pending", key: "Complaints Pending Status", icon: AlertCircle, color: "#f59e0b", gradient: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",path: "/complaints",},
  {label: "Circular Notices", key: "Circular Notice", icon: Megaphone, color: "#3b82f6", gradient: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",path: "/circular-Notice",},
  {label: "Total Members", key: "Member List", icon: Users, color: "#10b981", gradient: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)", path: "/memeber-list",},
  {label: "Service Providers", key: "Service Provider", icon: Briefcase, color: "#6366f1", gradient: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)", path: "/service-provider",},
  {label: "Emergency Contacts", key: "Emergency", icon: ShieldAlert, color: "#ef4444", gradient: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",path: "/emergency",},
  {label: "Receipts", key: "Receipt", icon: Receipt, color: "#8b5cf6",  gradient: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)", path: "/receipt",},
  {label: "Credit Notes", key: "Credit Note", icon: FileText, color: "#ec4899", gradient: "linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%)", path: "/credit-note", },
  {label: "Debit Notes", key: "Debit Note", icon: FileMinus, color: "#f43f5e", gradient: "linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)", path: "/debit-note-society-name",},
  {label: "Reports", key: "Reports", icon: BarChart2, color: "#14b8a6", gradient: "linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)", path: "/report",},
  {label: "Society Rules", key: "Rules", icon: BookOpen, color: "#84cc16", gradient: "linear-gradient(135deg, #f7fee7 0%, #ecfccb 100%)", path: null,},
  {label: "Bills", key: "Bill", icon: FileIcon, color: "#0ea5e9", gradient: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)", path: "/bill-society",},
  {label: "Parking Slots", key: "Parking", icon: Car, color: "#f97316", gradient: "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)", path: "/parking-list",},
];

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

const COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#ec4899"];

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [error, setError] = useState("");
  const [chartData, setChartData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeChart, setActiveChart] = useState("bar");
  const [loading, setLoading] = useState(true);
  const [visitorCount, setVisitorCount] = useState(0);
  const [countCompaints, setCountCompaints] = useState(0)
    const [data, setData] = useState(null);

  const navigate = useNavigate();

    useEffect(() => {
    const getComplaintCount = async () => {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");

      try {
        const response = await axios.post(
          `${BASE_URL}/complaint/get-count-complaints-by-society`,
          {},
          {
            params: {
              societyName: societyName
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        setCountCompaints(response.data);
        console.log("api call here "+ JSON.stringify(response.data))
      } catch (error) {
        console.error("Error fetching complaint count:", error);
      }
    };

    getComplaintCount();

  }, []);
  
  
    useEffect(() => {

    const getVisitorCount = async () => {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      try {
        const response = await axios.post(
          `${BASE_URL}/visitor/get-count-visitor-by-society`,
          {},
          {
            params: {
              societyName: societyName,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Visitor Count:", response.data);
        setVisitorCount(response.data);

      } catch (error) {
        console.error("Error fetching visitor count:", error);
      }
    };

    getVisitorCount();

  }, []);

    useEffect(() => {
    getCountForChats();
  }, []);

  const getCountForChats = async () => {
  try {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");

    const response = await axios.post(
      `${BASE_URL}/dynamic-table/get-count-for-chats?societyName=${encodeURIComponent(
        societyName
      )}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const res = response.data;

    console.log(res);

    // ⭐ Format month label from API date
    const monthLabel = new Date(res.monthAndDate).toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });

    // ⭐ Map API response → chartData format
    setChartData([
      {
        month: monthLabel,
        complaints: res.complaints || 0,
        visitors: res.visitors || 0,
        paymentsReceived: res.bills || 0,
        paymentsPending: res.receipts || 0,
        efficiency: Math.min(
          ((res.bills || 0) / 10) * 100,
          100
        ), // optional sample efficiency logic
      },
    ]);
  } catch (error) {
    console.log("Error fetching dashboard data:", error);
  }
}
  useEffect(() => {
    fetchDashboardData();
  }, [selectedYear]);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      await Promise.all([fetchCounts(), fetchChartData(selectedYear)]);
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError("Failed to fetch dashboard data");
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (path) => {
    if (path) navigate(path);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchCounts = async () => {
    const token = localStorage.getItem("token");
    const society = localStorage.getItem("society");

    if (!token) {
      setError("User not authenticated");
      return;
    }

    try {
      const response = await axios.get(
        `${BASE_URL}/api/dashboard/counts?tableName=${encodeURIComponent(
          society
        )}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStats(response.data || {});
    } catch (err) {
      console.error("Error fetching counts:", err);
      setError("Failed to fetch dashboard data");
    }
  };

  const fetchChartData = async (year) => {
    try {
      const token = localStorage.getItem("token");
      const society = localStorage.getItem("society");

      const response = await axios.get(
        `${BASE_URL}/api/dashboard/monthly?year=${year}&society=${encodeURIComponent(
          society
        )}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = response.data || [];
      const formatted = months.map((m) => {
        const item = data.find((d) => {
          if (!d) return false;
          const monthField = (d.month || d.monthName || "").toString();
          return monthField.toLowerCase() === m.toLowerCase();
        });

        const complaints = item
          ? Number(
              item.complaints ??
                item.Complaints ??
                item.complaint ??
                item.complaintCount ??
                item.complaint_count ??
                0
            )
          : 0;

        const visitors = item
          ? Number(
              item.visitors ??
                item.Visitors ??
                item.visitorCount ??
                item.visitor_count ??
                0
            )
          : 0;
        const paymentsReceived = item
          ? Number(
              item.paymentsReceived ??
                item.payments_received ??
                item.paymentReceived ??
                item.payment_received ??
                item.receivedPayments ??
                item.received_payments ??
                0
            )
          : 0;

        const paymentsPending = item
          ? Number(
              item.paymentsPending ??
                item.payments_pending ??
                item.paymentPending ??
                item.payment_pending ??
                item.notReceived ??
                item.not_received ??
                item.paymentNotReceived ??
                item.payment_not_received ??
                0
            )
          : 0;

        return {
          month: m,
          complaints,
          visitors,
          paymentsReceived,
          paymentsPending,
          revenue: paymentsReceived * 1000,
          efficiency:
            paymentsPending > 0
              ? (paymentsReceived / (paymentsReceived + paymentsPending)) * 100
              : 100,
        };
      });

      const total = formatted.reduce(
        (acc, r) =>
          acc +
          r.complaints +
          r.visitors +
          r.paymentsReceived +
          r.paymentsPending,
        0
      );

      if (total === 0) {
        setChartData(
          months.map((m) => ({
            month: m,
            complaints: Math.floor(Math.random() * 10),
            visitors: Math.floor(Math.random() * 50),
            paymentsReceived: Math.floor(Math.random() * 40),
            paymentsPending: Math.floor(Math.random() * 15),
            revenue: Math.floor(Math.random() * 40000),
            efficiency: 85 + Math.random() * 15,
          }))
        );
      } else {
        setChartData(formatted);
      }
    } catch (err) {
      console.error("Error fetching chart data:", err);
    }
  };

  

  const pieData = [
    {
      name: "Complaints",
      value: chartData.reduce((a, b) => a + b.complaints, 0),
    },
    { name: "Visitors", value: chartData.reduce((a, b) => a + b.visitors, 0) },
    {
      name: "Bill",
      value: chartData.reduce((a, b) => a + b.paymentsReceived, 0),
    },
    {
      name: "Receipt",
      value: chartData.reduce((a, b) => a + b.paymentsPending, 0),
    },
  ];

  const summaryStats = {
    totalComplaints: chartData.reduce((a, b) => a + b.complaints, 0),
    totalVisitors: chartData.reduce((a, b) => a + b.visitors, 0),
    totalRevenue: chartData.reduce((a, b) => a + b.paymentsReceived, 0) * 1000,
    totalPending: chartData.reduce((a, b) => a + b.paymentsPending, 0),
  };

  if (loading) {
    return (
      <div className="app-container">
        <Header toggleSidebar={toggleSidebar} />
        <div className="main-layout">
          <Sidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
          />
          <main className="content-area">
            <SubHeader />
            <div className="dashboard-inner loading">
              <div className="loading-spinner"></div>
              <p>Loading dashboard...</p>
            </div>
          </main>
        </div>
      </div>
    );
  }

  return (
    <>
      <style>
        {`
          /* ===============================
   BASE / LAYOUT
   =============================== */

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  overflow-x: hidden;
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

.app-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.main-layout {
  display: flex;
  min-height: calc(100vh - 64px);
  width: 100%;
}

.content-area {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  min-width: 0;
}

.dashboard-inner {
  max-width: 1400px;
  margin: 0 auto;
}

/* ===============================
   WELCOME HEADER
   =============================== */

.welcome-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  padding: 20px 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08);
}

.welcome-title {
  font-size: 26px;
  font-weight: 700;
  color: #1f2937;
}

.welcome-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.date-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}

.modern-date-input {
  border: none;
  background: transparent;
  font-weight: 600;
  width: 70px;
  text-align: center;
}

.modern-date-input:focus {
  outline: none;
}

/* ===============================
   SUMMARY CARDS
   =============================== */

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-bottom: 28px;
}

.summary-card {
  background: #fff;
  padding: 16px;
  border-radius: 14px;
  display: flex;
  gap: 14px;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);
}

.summary-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.summary-label {
  font-size: 13px;
  color: #6b7280;
}

.summary-value {
  font-size: 26px;
  font-weight: 700;
  color: #1f2937;
}

.summary-trend {
  font-size: 12px;
  color: #10b981;
  display: flex;
  gap: 4px;
  align-items: center;
}

.summary-trend.negative {
  color: #ef4444;
}

/* ===============================
   ULTRA-COMPACT STAT CARDS
   =============================== */

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 8px;
  margin-bottom: 32px;
}

.modern-stat-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.modern-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 18px -8px rgba(0,0,0,0.12);
}

.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.card-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-action svg {
  width: 12px;
  height: 12px;
}

.card-value {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1;
}

.card-label {
  font-size: 11.5px;
  color: #6b7280;
  margin-top: 2px;
}

.card-body {
  margin: 0;
}

/* ===============================
   CHARTS SECTION
   =============================== */

.charts-section {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);
  margin-bottom: 32px;
}

.charts-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
}

.section-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.chart-toggles {
  display: flex;
  gap: 10px;
}

.chart-toggle {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 13px;
  cursor: pointer;
}

.chart-toggle.active {
  background: #3b82f6;
  color: #fff;
  border-color: #3b82f6;
}

/* Charts layout */
.charts-container {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}

.chart-box {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  height: 400px;
}

.small-chart,
.metrics-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
}

.small-chart {
  height: 240px;
}

.chart-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
}

/* ===============================
   EFFICIENCY BAR
   =============================== */

.efficiency-chart {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.efficiency-bar {
  display: flex;
  align-items: center;
  gap: 10px;
}

.efficiency-label {
  width: 30px;
  font-size: 12px;
  color: #6b7280;
}

.efficiency-track {
  flex: 1;
  height: 6px;
  background: #f3f4f6;
  border-radius: 4px;
  overflow: hidden;
}

.efficiency-fill {
  height: 100%;
  border-radius: 4px;
}

.efficiency-value {
  width: 40px;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
}

/* ===============================
   RESPONSIVE
   =============================== */

@media (max-width: 1200px) {
  .charts-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .content-area {
    padding: 16px;
  }

  .welcome-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .summary-grid,
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .chart-box {
    height: 340px;
  }
}

@media (max-width: 480px) {
  .summary-grid,
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .chart-box {
    height: 300px;
  }
}
.chart-box {
  background: linear-gradient(180deg,#ffffff 0%, #fafafa 100%);
  border-radius: 22px;
  padding: 22px;
  box-shadow:
    0 10px 40px rgba(0,0,0,0.04),
    inset 0 1px 0 rgba(255,255,255,0.7);
}
          `}
      </style>

      <div className="app-container">
        <Header toggleSidebar={toggleSidebar} />

        <div className="main-layout">
          <Sidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
          />

          <main className="content-area">
            <SubHeader />

            <div className="dashboard-inner">
              {/* Welcome Header */}
              <div className="welcome-header">
                <div>
                  <h1 className="welcome-title" style={{ color: "#007BFF" }}>
    Dashboard Overview
  </h1>
  <p className="welcome-subtitle" style={{ color: "#007BFF" }}>
    Welcome back! Here's what's happening today.
  </p>
                </div>
                <div className="date-selector">
  <Calendar size={20} className="date-icon" color="#007BFF" />

  <DatePicker
    selected={new Date(selectedYear, 0, 1)}
    onChange={(date) => setSelectedYear(date.getFullYear())}
    showYearPicker
    dateFormat="yyyy"
    className="modern-date-input"
    style={{ color: "#007BFF" }}
  />

  <TrendingUp size={20} className="trend-icon" color="#007BFF" />
</div>
              </div>

              {error && <div className="error-toast">{error}</div>}

              <div className="summary-grid">
                <div className="summary-card">
                  <div
                    className="summary-icon"
                    style={{
                      background:
                        "linear-gradient(135deg, #f59e0b20, #f59e0b10)",
                    }}
                  >
                    <AlertTriangle color="#f59e0b" size={24} />
                  </div>
                  <div className="summary-content">
                  <p className="summary-label" style={{ color: "#007BFF" }}>
                    Total Complaints
                  </p>
                    <h3 className="summary-value" style={{ color: "#007BFF" }}>
                      {countCompaints}
                    </h3>
                    <p className="summary-trend">
                      <TrendingUp size={14} /> +12% from last year
                    </p>
                  </div>
                </div>

                <div className="summary-card">
                  <div
                    className="summary-icon"
                    style={{
                      background:
                        "linear-gradient(135deg, #10b98120, #10b98110)",
                    }}
                  >
                    <UserCheck color="#10b981" size={24} />
                  </div>
                  <div className="summary-content">
                    <p className="summary-label" style={{ color: "#007BFF" }}>Total Visitors</p>
                    <h3 className="summary-value" style={{ color: "#007BFF" }}>
                      {visitorCount}
                    </h3>
                    <p className="summary-trend">
                      <TrendingUp size={14} /> +8% from last month
                    </p>
                  </div>
                </div>

                <div className="summary-card">
                  <div
                    className="summary-icon"
                    style={{
                      background:
                        "linear-gradient(135deg, #3b82f620, #3b82f610)",
                    }}
                  >
                    <DollarSign color="#3b82f6" size={24} />
                  </div>
                  <div className="summary-content">
                    <p className="summary-label" style={{ color: "#007BFF" }}>Total Revenue</p>
                    <h3 className="summary-value" style={{ color: "#007BFF" }}>
                      ₹0
                    </h3>
                    <p className="summary-trend">
                      <TrendingUp size={14} /> +15% from last year
                    </p>
                  </div>
                </div>

                <div className="summary-card">
                  <div
                    className="summary-icon"
                    style={{
                      background:
                        "linear-gradient(135deg, #ef444420, #ef444410)",
                    }}
                  >
                    <Clock color="#ef4444" size={24} />
                  </div>
                  <div className="summary-content">
                    <p className="summary-label" style={{ color: "#007BFF" }}>Pending Payments</p>
                    <h3 className="summary-value" style={{ color: "#007BFF" }}>
                      0
                    </h3>
                    <p className="summary-trend negative">
                      <TrendingUp size={14} /> -5% from last month
                    </p>
                  </div>
                </div>
              </div>

              <div className="stats-grid">
                {cardConfig.map((card, index) => {
                  const Icon = card.icon;
                  const count = stats[card.key] || 0;

                  return (
                    <div
                      key={index}
                      className="modern-stat-card"
                      onClick={() => handleCardClick(card.path)}
                      role="button"
                      tabIndex={0}
                      style={{
                        cursor: card.path ? "pointer" : "default",
                        background: card.gradient,
                      }}
                    >
                      <div className="card-content">
                        <div className="card-header">
                          <div
                            className="card-icon"
                            style={{ backgroundColor: `${card.color}20` }}
                          >
                            <Icon
                              size={22}
                              color={card.color}
                              strokeWidth={2}
                            />
                          </div>
                          {card.path && (
                            <div className="card-action" style={{ color: "#007BFF" }}>
                              <ArrowUpRight size={16} strokeWidth={2.5}  />
                            </div>
                          )}
                        </div>
                        <div className="card-body">
                          <h3 className="card-value" style={{ color: "#007BFF",   fontWeight: "bold" }}>{count}</h3>
                          <p className="card-label" style={{ color: "#007BFF" }}>{card.label}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="charts-section">
                <div className="charts-header">
                  <div>
                    <h2 className="section-title" style={{ color: "#007BFF" }}>Analytics Dashboard</h2>
                    <p className="section-subtitle" style={{ color: "#007BFF" }}>
                      Monthly performance metrics and trends
                    </p>
                  </div>
                  <div className="chart-toggles">
                    <button
                      className={`chart-toggle ${
                        activeChart === "bar" ? "active" : ""
                      }`}
                      onClick={() => setActiveChart("bar")}
                    >
                      <BarChart2 size={16} style={{ color: "#007BFF" }} />
                      Bar Chart
                    </button>
                    <button
                      className={`chart-toggle ${
                        activeChart === "line" ? "active" : ""
                      }`}
                      onClick={() => setActiveChart("line")}
                      style={{ color: "#007BFF" }}
                    >
                      <TrendingUp size={16} />
                      Line Chart
                    </button>
                    <button
                      className={`chart-toggle ${
                        activeChart === "area" ? "active" : ""
                      }`}
                      onClick={() => setActiveChart("area")}
                    >
                      <AreaChart size={16} />
                      Area Chart
                    </button>
                  </div>
                </div>

                <div className="charts-container">
                  <div className="main-chart">
                    <div className="chart-box">
                      <ResponsiveContainer width="100%" height={400}>
                        {activeChart === "bar" ? (
                          <BarChart
                            data={chartData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                          >
                            <defs>
                              <linearGradient
                                id="colorComplaints"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset="5%"
                                  stopColor="#f59e0b"
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="95%"
                                  stopColor="#f59e0b"
                                  stopOpacity={0.1}
                                />
                              </linearGradient>
                              <linearGradient
                                id="colorVisitors"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset="5%"
                                  stopColor="#10b981"
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="95%"
                                  stopColor="#10b981"
                                  stopOpacity={0.1}
                                />
                              </linearGradient>
                              <linearGradient
                                id="colorReceived"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset="5%"
                                  stopColor="#3b82f6"
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="95%"
                                  stopColor="#3b82f6"
                                  stopOpacity={0.1}
                                />
                              </linearGradient>
                              <linearGradient
                                id="colorPending"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset="5%"
                                  stopColor="#ef4444"
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="95%"
                                  stopColor="#ef4444"
                                  stopOpacity={0.1}
                                />
                              </linearGradient>
                            </defs>
                            <CartesianGrid
                              strokeDasharray="3 3"
                              stroke="#f3f4f6"
                              vertical={false}
                            />
                            <XAxis
                              dataKey="month"
                              axisLine={false}
                              tickLine={false}
                              tick={{
                                fill: "#6b7280",
                                fontSize: 12,
                                fontWeight: 500,
                              }}
                            />
                            <YAxis
                              axisLine={false}
                              tickLine={false}
                              tick={{ fill: "#6b7280", fontSize: 12 }}
                            />
                            <Tooltip
                              contentStyle={{
                                borderRadius: "12px",
                                border: "1px solid #e5e7eb",
                                boxShadow:
                                  "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
                                background: "white",
                                padding: "12px 16px",
                              }}
                            />
                            <Legend />
                            <Bar
                              dataKey="complaints"
                              name="Complaints"
                              fill="url(#colorComplaints)"
                              radius={[8, 8, 0, 0]}
                            />
                            <Bar
                              dataKey="visitors"
                              name="Visitors"
                              fill="url(#colorVisitors)"
                              radius={[8, 8, 0, 0]}
                            />
                            <Bar
                              dataKey="paymentsReceived"
                              name="Bill"
                              fill="url(#colorReceived)"
                              radius={[8, 8, 0, 0]}
                            />
                            <Bar
                              dataKey="paymentsPending"
                              name="Receipt"
                              fill="url(#colorPending)"
                              radius={[8, 8, 0, 0]}
                            />
                          </BarChart>
                        ) : activeChart === "line" ? (
                          <LineChart
                            data={chartData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                          >
                            <CartesianGrid
                              strokeDasharray="3 3"
                              stroke="#f3f4f6"
                            />
                            <XAxis dataKey="month" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="complaints"
                              stroke="#f59e0b"
                              strokeWidth={3}
                              dot={{ r: 4 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="visitors"
                              stroke="#10b981"
                              strokeWidth={3}
                              dot={{ r: 4 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="paymentsReceived"
                              stroke="#3b82f6"
                              strokeWidth={3}
                              dot={{ r: 4 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="paymentsPending"
                              stroke="#ef4444"
                              strokeWidth={3}
                              dot={{ r: 4 }}
                            />
                          </LineChart>
                        ) : (
                          <AreaChart
                            data={chartData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                          >
                            <defs>
                              <linearGradient
                                id="colorArea"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset="5%"
                                  stopColor="#8884d8"
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="95%"
                                  stopColor="#8884d8"
                                  stopOpacity={0}
                                />
                              </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="month" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Area
                              type="monotone"
                              dataKey="paymentsReceived"
                              stroke="#8884d8"
                              fillOpacity={1}
                              fill="url(#colorArea)"
                            />
                          </AreaChart>
                        )}
                      </ResponsiveContainer>
                    </div>
                  </div>

                  <div className="side-charts">
                    <div className="small-chart">
                      <h4 className="chart-title" style={{ color: "#007BFF" }}>Distribution Overview</h4>
                      <ResponsiveContainer width="100%" height={200}>
                        <PieChart>
                          <Pie
                            data={pieData}
                            cx="50%"
                            cy="50%"
                            innerRadius={40}
                            outerRadius={70}
                            paddingAngle={2}
                            dataKey="value"
                          >
                            {pieData.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                              />
                            ))}
                          </Pie>
                          <Tooltip />
                          <Legend />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>

                    <div className="metrics-card">
                      <h4 className="chart-title" style={{ color: "#007BFF" }}>Monthly Efficiency</h4>
                      <div className="efficiency-chart">
                        {chartData.slice(-6).map((item, index) => (
                          <div key={index} className="efficiency-bar">
                            <div className="efficiency-label">{item.month}</div>
                            <div className="efficiency-track">
                              <div
                                className="efficiency-fill"
                                style={{
                                  width: `${Math.min(item.efficiency, 100)}%`,
                                  background:
                                    item.efficiency > 90
                                      ? "#10b981"
                                      : item.efficiency > 75
                                      ? "#f59e0b"
                                      : "#ef4444",
                                }}
                              />
                            </div>
                            <div className="efficiency-value">
                              {item.efficiency.toFixed(1)}%
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
